import { createTheme } from '@mui/material';
import { defaultStyleComponents } from './defaultStyleComponents';
import { defaultDarkColor, defaultLightColor } from './defaultColors';

export const yellowLightTheme = createTheme({
  components: { ...defaultStyleComponents },
  spacing: (abs: number) => `${0.35 * abs}rem`,
  palette: {
    mode: 'light',
    primary: {
      main: '#FFB800',
      900: '#332900',
      800: '#665200',
      700: '#997B00',
      600: '#CCA400',
      500: '#FFB800',
      400: '#FFC633',
      300: '#FFD466',
      200: '#FFE299',
      100: '#FFF0CC',
      50: '#FFF8E6',
    },
    ...defaultLightColor,
    customColor: {
      main: '#FFB800',
      100: '#CCA400',
      gradient:
        'linear-gradient(90deg, rgba(255, 184, 0, 0.1) 0%, rgba(255, 184, 0, 0.3) 100%)',
    },
    customColor2: {
      main: '#141414',
    },
    customColorTable: {
      main: '#FFB800',
      oddRow: '#FFF8E6',
    },
  },
});

export const yellowDarkTheme = createTheme({
  components: { ...defaultStyleComponents },
  spacing: (abs: number) => `${0.35 * abs}rem`,
  palette: {
    mode: 'dark',
    primary: {
      main: '#FFB800',
      900: '#141414',
      100: '#332900',
      700: '#665200',
      600: '#997B00',
      500: '#CCA400',
      400: '#FFB800',
      300: '#FFC633',
      200: '#FFD466',
      800: '#1a1a1a',
      50: '#262626',
    },
    ...defaultDarkColor,
    customColor: {
      main: '#FFB800',
      100: '#FFC633',
      gradient:
        'linear-gradient(90deg, rgba(20, 20, 20, 0.8) 0%, rgba(255, 184, 0, 0.3) 100%)',
    },
    customColor2: {
      main: '#141414',
    },
    customColorTable: {
      main: '#FFB800',
      oddRow: '#1a1a1a',
    },
  },
});
